//import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
//
import Link from "@mui/material/Link";
import { Link as RLink } from "react-router-dom";

interface QueryProps {
    id: string | null;
    page_id: string;
    onSave: () => void;
}

export default function ButtonAppBar({ id, page_id, onSave }: QueryProps) {
    return (
        <Toolbar>
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
            >
                <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                News
            </Typography>
            <Button color="inherit" onClick={onSave}>
                Save
            </Button>
            <Link component={RLink} to={"/ticket/view" + page_id}>
                <Button variant="outlined" size="small" onClick={onSave}>
                    To Page
                </Button>
            </Link>
        </Toolbar>
    );
}
